import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef } from "react";
import Svg, { Circle, Path } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { incrementnewsPopUpShownCount, setLocalNewsLetterSubscribed, setAppDownloadPopupShown, incrementAppDownloadPopupShownCount } from "appRedux/reducers/authSlice";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "./BottomSheetModal";
import Carousel from "react-native-reanimated-carousel";

import Pagination from "./Pagination";
import { REGEX } from "utils/Constants";
import VText from "./VText";
import { newsLetterSubscribe } from "appRedux/reducers/profileSlice";
import { useGlobalSearchParams } from "expo-router";
import { useState } from "react";
import { Images } from "assets";


const data = [
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/homepage.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/PDP.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/New+Arrivals.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    },
];

export default React.forwardRef((props, ref) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const dispatch = useDispatch();
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();

    const global = useGlobalSearchParams();
    const gender = global?.gender || "female";

    React.useImperativeHandle(
        ref,
        () => ({
            show,
            hide,
        }),
        []
    );

    const show = () => {
        _bottomSheetRef?.current?.show();
    };

    const hide = () => {
        _bottomSheetRef?.current?.hide();
        dispatch(incrementAppDownloadPopupShownCount());
    };

  

    const _renderItem = ({ item, index }) => {
        const isActive = activeIndex === index;
        return (
            <Image
                source={item.image}
                accessibilityLabel={`Newsletter Image ${index + 1}`}
                style={{ width: wp(220), height: hp(400), opacity: isActive ? 1 : 0.5 }}
                resizeMode="contain"
            ></Image>
        );
    };

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={hide}
            >
                <TouchableOpacity
                    style={{
                        width: wp(856),
                        height: hp(456),
                        backgroundColor: "#fff",
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    <View
                            style={{
                                backgroundColor: "white",
                                flexDirection: "row",
                                alignItems: "center",
                                overflow: "hidden",
                            }}
                        >
                            <View
                                style={{
                                    width: wp(410),
                                    height: hp(466),
                                    backgroundColor: "black",
                                    overflow: "hidden",
                                }}
                            >
                                <View
                                    style={{
                                        // marginTop: 80,
                                    }}
                                >
                                    <Carousel
                                        loop
                                        width={wp(235)}
                                        height={hp(390)}
                                        autoPlay={true}
                                        autoPlayInterval={2000}
                                        data={data}
                                        onConfigurePanGesture={(PanGesture) => {}}
                                        style={{
                                            width: wp(410),
                                            alignItems: "center",
                                            alignContent: "center",
                                            justifyContent: "center",
                                            // backgroundColor: "red",
                                            paddingLeft:'10px'
                                        }}
                                        mode="parallax"
                                        scrollAnimationDuration={1000}
                                        renderItem={_renderItem}
                                        onSnapToItem={(index) => setActiveIndex(index)}
                                    />
                                    <Pagination
                                        backgroundColor="white"
                                        data={Array.isArray(data) ? data : []}
                                        selectedIndex={activeIndex}
                                        thickness={8}
                                        containerStyle={{
                                            paddingVertical: 14,
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    />
                                </View>
                            </View>
                            <View
                                style={{
                                    width: wp(441),
                                    height: hp(466),
                                    paddingHorizontal: wp(80),
                                    paddingVertical: hp(40),
                                    // paddingTop: hp(90),
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                   <TouchableOpacity
                                    onPress={hide}
                                    activeOpacity={0.8}
                                    style={{
                                        position: "absolute",
                                        right: 20,
                                        top: 20,
                                    }}
                                >
                                    <Svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                                        <Path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                            fill="#212427"
                                        />
                                    </Svg>
                                </TouchableOpacity>
                                <Image source={Images.appQR} resizeMode="contain" style={{ width: wp(130), height: hp(130), marginBottom: spV(20) }} />
                                <VText style={styles.aboutHeadingText}>
                                Get 10% off on the app!
                                </VText>
                                <VText style={styles.aboutSubText}>    
                                Enjoy an exclusive 10% off on the app using code <span style={{ fontWeight: "650" }}>WELCOME10</span>. Simply scan the QR code to download.
                                </VText>
                            </View>
                        </View>
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "rgba(240, 240, 240, 1)",
        paddingVertical: spV(48),
        paddingHorizontal: spH(60),
        flexDirection: "row",
    },
    successModalContainer: {
        flex: 1,
        alignItems: "center",
    },

    aboutTextContainer: {
        flex: 1,
    },
    aboutHeadingText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(24),
        fontWeight: "400",
        textAlign: "center",
    },
    aboutSubText: {
        marginTop: spV(10),
        fontSize: fp(16),
        fontWeight: "300",
        textAlign: "center",
        lineHeight: '140%'
    },
 
    
});
